import cx from 'classnames'

import Styles from './Properties.module.scss'

import { useMultipleAssigneesProperties } from 'hooks/useMultipleAssigneesProperties'
import { useFinderContext } from 'screens/Finder/FinderContext'
import { showToastMessage } from 'common/ToastMessage/ShowToastMessage'

import { ReactComponent as RemoveIcon } from 'assets/icons/trash16.svg'
import { Button } from 'components/Button/Button'
import { Property, AssigneeType } from 'api/clients/PropertyClient'
import { FileType } from 'types'

type Props = {
  property: Property
  onClose: () => void
}

export const FILE_TYPES_MAP: { [key in FileType]: AssigneeType } = {
  article: AssigneeType.Article,
  handbook: AssigneeType.Article,
  folder: AssigneeType.Project,
  media_file: AssigneeType.MediaFile,
  design: AssigneeType.Design,
  video: AssigneeType.Video,
}

// Unassigns the property from all files in folder
// Should only be called for workspace properties
// Folder properties need to use DeleteProperty.tsx
export const RemoveProperty = ({ property, onClose }: Props) => {
  const { filesView, removePropertyFromSchema, removePropertyFromHistorical } = useFinderContext()

  // TODO: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
  const assignees = filesView!.files!.map(({ id, type }) => ({ id, type: FILE_TYPES_MAP[type] }))
  const { removePropertyFromAssignees } = useMultipleAssigneesProperties({ assignees })

  const confirmRemove = async () => {
    await Promise.all([
      removePropertyFromAssignees(property.id, { only_empty: true }),
      // TODO: Fix this the next time the file is edited.
      // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
      ...(filesView!.schema!.historical_properties.some(({ id }) => property.id === id)
        ? [removePropertyFromHistorical(property.id)]
        : []),
      // TODO: Fix this the next time the file is edited.
      // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
      ...(filesView!.schema!.properties.some(({ id }) => property.id === id)
        ? [removePropertyFromSchema(property.id)]
        : []),
    ])
    onClose()
    showToastMessage(`"${property.name}" has been removed in this folder.`)
  }

  return (
    <div className={Styles.flexContainer}>
      <Button
        className={cx(Styles.flexContainer, Styles.flexGrow, Styles.horizontalPadding, Styles.columnGap0)}
        variant="tertiary"
        size="lg"
        onPress={confirmRemove}
      >
        <RemoveIcon className={Styles.icon} />
        <div>Remove</div>
      </Button>
    </div>
  )
}
